<template>
  <div class="header-container">
    <img :src="logoSrc" alt="Logo" class="logo"/>
    <img :src="require('@/assets/images/more.png')" alt="more" class="more">
  </div>
</template>

<script>
import LogoImage from '@/assets/images/am_logo 1.svg';
import ProfilePicture from '@/assets/images/profile-picture-example.svg';

export default {
  name: 'HeaderComponent',
  data() {
    return {
      logoSrc: LogoImage,
      profilePicture: ProfilePicture,
      navigationLinks: [
        { name: 'СМИ', path: '/media' },
        { name: 'Аналитика', path: '/analytics' },
        { name: 'Мероприятия', path: '/events' },
        { name: 'Сообщество', path: '/community' },
        { name: 'Партнеры', path: '/partners' },
      ],
    };
  },
};
</script>

<style scoped>
.logo {
  width: 202px;
  height: 24px;
  margin-top: 16px;
}
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  margin-left: 20px;
  margin-right: 20px;
  border-bottom: 1px solid rgba(87, 90, 96, 0.2);
}

.more {
  width: 32px;
  height: 24px;
}

</style>
